// keeping this file for backward compatibility, but the calendar code has been moved to a separate directory
// probably this should be removed and the calendar code should become a Stimulus controller at some point
import calendar from './calendar/index'

export default calendar
